import React from 'react';

function Input({ type, id, value, onChange, ...props }) {
  return (
    <div>
      <input 
        type={type} 
        id={id} 
        value={value} 
        onChange={onChange} 
        {...props} 
      />
    </div>
  );
}

export default Input;